import React, {Component} from 'react';

import API from '../../../api';



class QuestionsController extends Component{
  constructor(props){
    super(props);
    this.tracking = this.tracking.bind();
  }
  tracking = (e) => {
    API.trackingEvent("User","Click on info@app2soft link");
  }
  render(){
    return(
      <section className="questions">
        <h2>{this.props.content.title}</h2>
        <p onClick={e => this.tracking(e)} dangerouslySetInnerHTML={{__html: this.props.content.description}}></p>
      </section>
    )
  }
}

export default QuestionsController;



// WEBPACK FOOTER //
// ./src/components/clients_page/views/questions.js